import React from 'react'
import './styles/home.css';
import { Link, useNavigate } from 'react-router-dom'

const AboutHome = () => {
    const navigate = useNavigate();

    const handleAboutLinkClick = () => {
        navigate("/about");
    }
    return (



        <div id='jokes-main'>
            <div id='ablgmb' style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
                <img id='b-b-logo-title' src={process.env.PUBLIC_URL + 'images/logo-gold.png'}></img>
                <h2 id='b-bands'>BETWEEN CHOIRS</h2>
            </div>

            <div id='mobile-title-ab'>
                <img src='images/logo-gold.png' />
                <div>
                    <h2>BETWEEN</h2>
                    <h2>CHOIRS</h2>
                </div>
            </div>
            <h3 id='marching-band-jokes-2'>Who Are We?</h3>
            <div id='jokes'>

                <div id='jokes-img-logo'>
                    <img id='between-bands-logo' src={process.env.PUBLIC_URL + 'images/logo-gold.png'}></img>
                </div>


                <div id='jokes-description'>
                    <h3 id='marching-band-jokes'>Who Are We?</h3>
                    <p>
                        Welcome to Between Choirs—where the magic of show choir extends beyond the stage! Between Choirs transforms downtime between performances into a celebration of music, artistry, and connection. Dive into engaging articles, fun activities, and games that keep the energy alive for performers, parents, and fans alike.
                    </p>

                    <button onClick={handleAboutLinkClick} className='gold-gradient-wshimmer' id='jokes-btn'>Learn More</button>



                </div>
            </div>


            <button onClick={handleAboutLinkClick} className='gold-gradient-wshimmer' id='jokes-btn-2'>Learn More</button>



        </div>

    )
}

export default AboutHome